import { motion } from "framer-motion";
import { Smartphone, Globe, Palette, Server } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const META = [
  { icon: Smartphone, tags: ["iOS", "Android", "Flutter", "React Native"], span: "md:col-span-7" },
  { icon: Globe, tags: ["Next.js", "React", "Node.js", "SEO"], span: "md:col-span-5" },
  { icon: Palette, tags: ["Figma", "Design System", "Prototype"], span: "md:col-span-5" },
  { icon: Server, tags: ["REST", "GraphQL", "AWS", "PostgreSQL"], span: "md:col-span-7" },
];

export default function Services() {
  const { t } = useLang();
  return (
    <section id="hizmetler" className="relative py-24 lg:py-32" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="glow-badge rounded-full px-4 py-1.5 text-xs font-medium tracking-widest uppercase">
            {t.services.badge}
          </span>
          <h2 className="mt-6 font-heading font-black tracking-tighter text-white text-3xl md:text-5xl max-w-2xl">
            {t.services.title_pre}
            <span className="text-[#5B7FFF]">{t.services.title_accent}</span>
          </h2>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-6">
          {t.services.items.map((s, i) => {
            const Icon = META[i].icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
                className={`group glass-card rounded-2xl p-8 lg:p-10 ${META[i].span} hover:border-[#5B7FFF]/40 transition-colors duration-300`}
                data-testid={`service-card-${i}`}
              >
                <div className="w-12 h-12 rounded-xl glow-badge flex items-center justify-center transition-transform duration-300 group-hover:-translate-y-1 group-hover:scale-105">
                  <Icon size={22} />
                </div>
                <h3 className="mt-6 font-heading font-bold text-white text-lg md:text-lg tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm md:text-base text-slate-400 leading-relaxed">{s.desc}</p>
                <div className="mt-6 flex flex-wrap gap-2">
                  {META[i].tags.map((tag) => (
                    <span key={tag} className="text-xs px-3 py-1 rounded-full border border-white/10 text-slate-400 group-hover:border-[#5B7FFF]/30 group-hover:text-slate-300 transition-colors duration-300">
                      {tag}
                    </span>
                  ))}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
